<!-- Input Checkbox Template -->
<ng-template #input_checkbox_template>
  <div class="flex align-items-center p-2 h-full">
    <p-checkbox inputId="{{ name }}"
      class="flex"
      ariaLabelledBy="{{ name }}_label"
      styleClass="{{ inputClass }} align-self-center"
      formControlName="{{ name }}"
      [binary]="true"
      [trueValue]="trueValue"
      [falseValue]="falseValue"
      [disableControl]="disabled"
                [ngClass]="{
                'ng-invalid': control.invalid && control.touched,
                'ng-dirty': control.invalid && control.touched
                }"
      (onChange)="valueChange.emit($event)">
    </p-checkbox>
    @if (!labelTop && label) {
      <label
        id="{{ name }}_label"
        class="flex flex-grow-1 ml-2"
        for="{{ name }}">
        <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
          {{ label | translate }}
        </span>
      </label>
    }
  </div>
</ng-template>
<!-- Checkbox Input -->
@if (name) {
  <div class="w-full"
       [class.field]="formField">
    @if (labelTop && label) {
      <label
        id="{{ name }}_label"
        class="flex flex-grow-1"
        [class.mb-2]="!formField"
        for="{{ name }}">
        <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
          {{ label | translate }}
        </span>
      </label>
    }
    @if (!inputGroup) {
      <ng-container *ngTemplateOutlet="input_checkbox_template"></ng-container>
    } @else {
      <div medsurf-design-content-input-group>
        <ng-container *ngTemplateOutlet="input_checkbox_template"></ng-container>
        <ng-content></ng-content>
      </div>
    }
    @if (control.invalid && (control.dirty || control.touched)) {
      <br/>
      @for (err of control.errors | keyvalue; track err) {
        <small id="{{ name }}_help"
          class="p-error w-max">
          {{ err.value | translate }}
        </small>
        <br/>
      }
    }
  </div>
}
